<template lang="pug">
v-layout(row justify-center)
  v-dialog(data-cy="add-modal.dialog" :value="value" persistent max-width="620")
    v-card
      title-bar(data-cy="add-modal.title" dark) Share with Sub-Account
      v-card-text
        p This allows anyone who you have listed as a sub-account to access this campaign.
        p 
          a(href="https://lonewolf.my.site.com/s/article/LD-Add-a-sub-account-LionDesk" target="_blank") Click here
          span &nbsp;to learn how to add sub-account members
      v-card-actions
        v-spacer
        v-btn(data-cy="share-campaign-modal.cancel" flat @click="closeDialog(false)") Cancel
        v-btn.primary(data-cy="share-campaign-modal.share" @click="closeDialog(true)") Share
</template>
<script>

import TitleBar from '@/Core/components/TitleBar';

export default {
  components: {
    TitleBar,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeDialog(resourceSubmitted = false) {
      this.$emit('close', resourceSubmitted);
    },
  },
};
</script>
